<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ایجاد سطح اساتید جدید</h1>
          <b-row>
            <b-col cols="12">
              <b-form-group label="عنوان سطح" label-for="title">
                <b-form-input
                  v-model="newLevelDetails.title"
                  id="title"
                  trim
                  placeholder="برای مثال برنز"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="از چند ساعت در هفته (برای مثال از 4 ساعت)"
                label-for="fromHour"
              >
                <b-form-input
                  v-model="newLevelDetails.fromHour"
                  id="fromHour"
                  trim
                  type="number"
                  placeholder="4"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="تا چند ساعت در هفته (برای مثال تا 6 ساعت)"
                label-for="toHour"
              >
                <b-form-input
                  v-model="newLevelDetails.toHour"
                  id="toHour"
                  trim
                  type="number"
                  placeholder="6"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="نسبت درآمد استاد در این سطح به قیمت پایه (به درصد)"
                label-for="percent"
              >
                <b-input-group append="%">
                  <b-input-group-prepend is-text>
                    <b-form-checkbox v-model="hasMaxPrice">
                      <small style="margin-right: 4px">
                        حداکثر مبلغ دارد؟
                      </small>
                    </b-form-checkbox>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="newLevelDetails.percent"
                    id="percent"
                    trim
                    type="number"
                    placeholder="6"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="حداکثر مبلغ با توجه به درصد"
                label-for="maxPrice"
              >
                <b-form-input
                  :disabled="!hasMaxPrice"
                  v-model="newLevelDetails.maxPrice"
                  id="maxPrice"
                  trim
                  type="number"
                  placeholder="50000"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="نسبت پرداختی زبان آموز به قیمت پایه (به درصد)"
                label-for="userPercent"
              >
                <b-form-input
                  v-model="newLevelDetails.userPercent"
                  id="userPercent"
                  trim
                  type="number"
                  placeholder="6"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="تعداد هفته‌ی مورد نیاز در این سطح برای رفتن به سطح بعدی"
                label-for="weekCount"
              >
                <b-form-input
                  v-model="newLevelDetails.weekCount"
                  id="weekCount"
                  trim
                  type="number"
                  placeholder="6"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="رنگ سطح استاد" label-for="colorCode">
                <b-input-group size="lg" :append="newLevelDetails.colorCode">
                  <b-form-input
                    v-model="newLevelDetails.colorCode"
                    id="colorCode"
                    trim
                    type="color"
                    placeholder="3"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="آیا این سطح بج دارد؟" label-for="showSvg">
                <b-form-checkbox
                  id="showSvg"
                  name="check-button"
                  switch
                  v-model="newLevelDetails.showSVG"
                >
                  <small style="margin-left: 3px">
                    {{ newLevelDetails.showSVG ? "بله" : "خیر" }}
                  </small>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="بج استاد" label-for="svg">
                <b-form-file
                  ref="svgFile"
                  id="svg"
                  v-model="newLevelDetails.SVGFile"
                  accept=".jpg,.jpeg,.png,.svg"
                  @input="handleImageFile"
                ></b-form-file>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6" v-if="imagePreview">
              <div class="d-flex flex-column align-items-center">
                <div class="d-flex align-items-center justify-content-between">
                  <small>پیشنمایش</small>
                  <b-button variant="transparent" @click="removePreviewImage">
                    <feather-icon
                      icon="Trash2Icon"
                      size="20"
                      class="text-danger"
                    />
                  </b-button>
                </div>
                <img
                  style="
                    max-height: 10rem;
                    max-width: auto;
                    object-fit: contain;
                  "
                  :src="imagePreview"
                  alt=""
                />
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group label="توضیحات سطح" label-for="description">
                <b-form-textarea
                  placeholder="توضیحات سطح اساتید"
                  id="description"
                  trim
                  v-model="newLevelDetails.description"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox v-model="newLevelDetails.canUseCustomePrice">
                <small>آیا این سطح قیمت شخصی سازی شده دارد؟</small>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                @click="createNewMasterLevel"
                variant="success"
                :disabled="isSubmitButtonDisabled"
              >
                ثبت
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      newLevelDetails: {
        id: 0,
        title: null,
        fromHour: null,
        toHour: null,
        percent: null,
        userPercent: null,
        maxPrice: null,
        colorCode: "#ffffff",
        canUseCustomePrice: false,
        description: null,
        weekCount: 0,
        showSVG: false,
        SVGFile: null,
      },
      hasMaxPrice: false,
      imagePreview: null,
      imageItself: null,
    };
  },
  methods: {
    removePreviewImage() {
      URL.revokeObjectURL(this.imagePreview);
      this.imagePreview = null;
      this.imageItself = null;
      this.$refs.svgFile.value = "";
    },
    handleImageFile() {
      if (this.$refs.svgFile) {
        this.imageItself = this.$refs.svgFile.files[0];
        this.imagePreview = URL.createObjectURL(this.imageItself);
      }
    },
    convertNumbers2English(number) {
      return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) & 0xf;
      });
    },
    async createNewMasterLevel() {
      try {
        this.isLoading = true;
        // Make sure number is in english
        this.newLevelDetails.fromHour = this.convertNumbers2English(
          this.newLevelDetails.fromHour
        );
        this.newLevelDetails.toHour = this.convertNumbers2English(
          this.newLevelDetails.toHour
        );
        // Set maxprice to null if user has not check the checkbox
        // For maxprice
        if (!this.hasMaxPrice) {
          this.newLevelDetails.maxPrice = null;
        }
        let myFormData = new FormData();
        Object.keys(this.newLevelDetails).forEach((key) => {
          if (this.newLevelDetails[key]) {
            myFormData.append(key, this.newLevelDetails[key]);
          }
        });
        let _this = this;
        let createNewMasterLevel = new CreateNewMasterLevel(_this);
        createNewMasterLevel.setFormData(myFormData);
        await createNewMasterLevel.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "سطح با موفقیت ایجاد شد.",
              },
            });
            _this.removePreviewImage();
            _this.newLevelDetails = {
              id: 0,
              title: null,
              fromHour: null,
              toHour: null,
              percent: null,
              userPercent: null,
              maxPrice: null,
              colorCode: "#ffffff",
              canUseCustomePrice: false,
              description: null,
              weekCount: 0,
              showSVG: false,
              SVGFile: null,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.data.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (
        !this.newLevelDetails.title ||
        this.newLevelDetails.fromHour == null ||
        !this.newLevelDetails.toHour ||
        !this.newLevelDetails.description
      ) {
        return true;
      }
      return false;
    },
  },

  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormTextarea,
    BOverlay,
    BInputGroup,
    BInputGroupPrepend,
    BFormFile,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormTextarea,
  BOverlay,
  BInputGroup,
  BInputGroupPrepend,
  BFormFile,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { CreateNewMasterLevel } from "@/libs/Api/ScheduleMasterRegular";
</script>
